export default {
	props: {
		
	},

	data() {
    return {
 
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/club-loyalty/club-loyalty-listing/club-loyalty-listing.js